import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './SectionReveal.module.css';

gsap.registerPlugin(ScrollTrigger);

function SectionReveal({ children, id, className = '', tag: Tag = 'section', ...props }) {
  const containerRef = useRef(null);
  const lineRef = useRef(null);
  const glowRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    const line = lineRef.current;
    const glow = glowRef.current;
    if (!el || !line || !glow) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    const ctx = gsap.context(() => {
      gsap.set(line, { scaleX: 0, opacity: 1, transformOrigin: 'left center' });
      gsap.set(glow, { opacity: 0, scale: 0.5 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: 'top 82%',
          toggleActions: 'play none none none',
        },
      });

      tl.to(line, { scaleX: 1, duration: 0.65, ease: 'power2.inOut' })
        .to(glow, { opacity: 1, scale: 1, duration: 0.4, ease: 'power2.out' }, '-=0.25')
        .to(glow, { opacity: 0, scale: 1.4, duration: 0.55, ease: 'power1.in' }, '+=0.1')
        .to(line, { opacity: 0, duration: 0.35, ease: 'power1.in' }, '-=0.4');
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <Tag id={id} ref={containerRef} className={className} {...props}>
      <div ref={lineRef} className={styles.portalLine} aria-hidden="true" />
      <div ref={glowRef} className={styles.portalGlow} aria-hidden="true" />
      {children}
    </Tag>
  );
}

export default SectionReveal;
